// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CurieAICard-module__font-s-10___nYgd2 {
  font-size: 10px !important;
}

.CurieAICard-module__font-s-12___CAtOC {
  font-size: 12px !important;
}

.CurieAICard-module__font-s-13___CDiyh {
  font-size: 13px !important;
}

.CurieAICard-module__font-s-14___U1dmi {
  font-size: 14px !important;
}

.CurieAICard-module__font-s-15___D8Njs {
  font-size: 15px !important;
}

.CurieAICard-module__font-s-16___KhNPG {
  font-size: 16px !important;
}

.CurieAICard-module__font-s-18___g7KBM {
  font-size: 18px !important;
}

.CurieAICard-module__font-s-20___6m7w5 {
  font-size: 20px !important;
}

.CurieAICard-module__font-s-22___XSAel {
  font-size: 22px !important;
}

.CurieAICard-module__font-s-28___pkQTh {
  font-size: 28px !important;
}

.CurieAICard-module__font-w-400___rolsN {
  font-weight: 400 !important;
}

.CurieAICard-module__font-w-500___SDN7j {
  font-weight: 500 !important;
}

.CurieAICard-module__font-w-600___ud3Rt {
  font-weight: 600 !important;
}

.CurieAICard-module__font-w-700____XNmU {
  font-weight: 700 !important;
}

.CurieAICard-module__p-5___ORiFf {
  padding: 5px !important;
}

.CurieAICard-module__p-12___VIN9Y {
  padding: 12px !important;
}

.CurieAICard-module__p-16___FJnB7 {
  padding: 16px !important;
}

.CurieAICard-module__p-30___yIoUS {
  padding: 30px !important;
}

.CurieAICard-module__p-b-0___b2Hhc {
  padding-bottom: 0 !important;
}

.CurieAICard-module__p-b-5___jpEzI {
  padding-bottom: 5px !important;
}

.CurieAICard-module__p-b-10___l819O {
  padding-bottom: 10px !important;
}

.CurieAICard-module__p-b-12___ZaxUu {
  padding-bottom: 12px !important;
}

.CurieAICard-module__p-b-16___DgFT9 {
  padding-bottom: 16px !important;
}

.CurieAICard-module__p-b-18___Auh0m {
  padding-bottom: 18px !important;
}

.CurieAICard-module__p-b-20___v5mGG {
  padding-bottom: 20px !important;
}

.CurieAICard-module__p-b-25___wROQj {
  padding-bottom: 25px !important;
}

.CurieAICard-module__p-b-30___Qrt4c {
  padding-bottom: 30px !important;
}

.CurieAICard-module__p-b-50___DySBs {
  padding-bottom: 50px !important;
}

.CurieAICard-module__p-t-0___d8ml7 {
  padding-top: 0 !important;
}

.CurieAICard-module__p-t-12___i3WiH {
  padding-top: 12px !important;
}

.CurieAICard-module__p-t-16___miU_Y {
  padding-top: 16px !important;
}

.CurieAICard-module__p-t-18___oSDlh {
  padding-top: 18px !important;
}

.CurieAICard-module__p-t-20___VLEDk {
  padding-top: 20px !important;
}

.CurieAICard-module__p-t-30___xm9DS {
  padding-top: 30px !important;
}

.CurieAICard-module__p-t-40___xI_mo {
  padding-top: 40px !important;
}

.CurieAICard-module__p-t-50___r3NwQ {
  padding-top: 50px !important;
}

.CurieAICard-module__p-l-20___EMuKG {
  padding-left: 20px !important;
}

.CurieAICard-module__p-l-30___NFrb1 {
  padding-left: 30px !important;
}

.CurieAICard-module__p-l-40___VQ5b6 {
  padding-left: 40px !important;
}

.CurieAICard-module__p-r-16___pOg7u {
  padding-right: 16px !important;
}

.CurieAICard-module__p-r-20___N8fA9 {
  padding-right: 20px !important;
}

.CurieAICard-module__p-r-30___rWuMj {
  padding-right: 30px !important;
}

.CurieAICard-module__p-r-50___ZdyCP {
  padding-right: 50px !important;
}

.CurieAICard-module__p-r-60___Og6Ua {
  padding-right: 60px !important;
}

.CurieAICard-module__m-b-1___o1W_A {
  margin-bottom: 1px !important;
}

.CurieAICard-module__m-b-2___YJ_4d {
  margin-bottom: 2px !important;
}

.CurieAICard-module__m-b-6___ibjPE {
  margin-bottom: 6px !important;
}

.CurieAICard-module__m-b-8___JG_Ym {
  margin-bottom: 8px !important;
}

.CurieAICard-module__m-b-10___oX4zV {
  margin-bottom: 10px !important;
}

.CurieAICard-module__m-b-14___f2S2Y {
  margin-bottom: 14px !important;
}

.CurieAICard-module__m-b-16___ykh7D {
  margin-bottom: 16px !important;
}

.CurieAICard-module__m-b-20___Pgz4O {
  margin-bottom: 20px !important;
}

.CurieAICard-module__m-b-22___Uc158 {
  margin-bottom: 22px !important;
}

.CurieAICard-module__m-b-24___DhzIx {
  margin-bottom: 24px !important;
}

.CurieAICard-module__m-b-30___s3ehs {
  margin-bottom: 30px !important;
}

.CurieAICard-module__m-b-32___Bi4ur {
  margin-bottom: 32px !important;
}

.CurieAICard-module__m-b-40___kfwao {
  margin-bottom: 40px !important;
}

.CurieAICard-module__m-t-2___kkZIH {
  margin-top: 2px !important;
}

.CurieAICard-module__m-t-3___E7dUW {
  margin-top: 3px !important;
}

.CurieAICard-module__m-t-4___gf6sW {
  margin-top: 4px !important;
}

.CurieAICard-module__m-t-5___v8OsQ {
  margin-top: 5px !important;
}

.CurieAICard-module__m-t-8___tBz6T {
  margin-top: 8px !important;
}

.CurieAICard-module__m-t-10___qTcBi {
  margin-top: 10px !important;
}

.CurieAICard-module__m-t-15___as0Bl {
  margin-top: 15px !important;
}

.CurieAICard-module__m-t-16___EvBGL {
  margin-top: 16px !important;
}

.CurieAICard-module__m-t-20___hCEhV {
  margin-top: 20px !important;
}

.CurieAICard-module__m-t-22___ECQDO {
  margin-top: 22px !important;
}

.CurieAICard-module__m-t-30___cC2cs {
  margin-top: 30px !important;
}

.CurieAICard-module__m-t-32___FejeC {
  margin-top: 32px !important;
}

.CurieAICard-module__m-l-auto___ph0Fc {
  margin-left: auto !important;
}

.CurieAICard-module__m-l-4___qDlvi {
  margin-left: 4px !important;
}

.CurieAICard-module__m-l-5___iVvMQ {
  margin-left: 5px !important;
}

.CurieAICard-module__m-l-6___stCVZ {
  margin-left: 6px !important;
}

.CurieAICard-module__m-l-8___DQgQZ {
  margin-left: 8px !important;
}

.CurieAICard-module__m-l-10___EoTJD {
  margin-left: 10px !important;
}

.CurieAICard-module__m-l-16___UlSHN {
  margin-left: 16px !important;
}

.CurieAICard-module__m-l-20___oKsiH {
  margin-left: 20px !important;
}

.CurieAICard-module__m-l-24___nD2X7 {
  margin-left: 24px !important;
}

.CurieAICard-module__m-l-30___iwt9L {
  margin-left: 30px !important;
}

.CurieAICard-module__m-l-35___ra2HE {
  margin-left: 35px !important;
}

.CurieAICard-module__m-l-40___nYWcj {
  margin-left: 40px !important;
}

.CurieAICard-module__m-r-8___S5NTf {
  margin-right: 8px !important;
}

.CurieAICard-module__m-r-10___eUjJk {
  margin-right: 10px !important;
}

.CurieAICard-module__m-r-16___QJhq7 {
  margin-right: 16px !important;
}

.CurieAICard-module__m-r-20___BRLSJ {
  margin-right: 20px !important;
}

.CurieAICard-module__m-r-24___OfR73 {
  margin-right: 24px !important;
}

.CurieAICard-module__m-r-30___YtPv4 {
  margin-right: 30px !important;
}

.CurieAICard-module__m-r-40___ZHfiA {
  margin-right: 40px !important;
}

.CurieAICard-module__border-r-3___i0ddB {
  border-radius: 3px !important;
}

.CurieAICard-module__border-r-4___sLJZe {
  border-radius: 4px !important;
}

.CurieAICard-module__border-r-6___y25be {
  border-radius: 6px !important;
}

.CurieAICard-module__border-r-10___D0dxM {
  border-radius: 10px !important;
}

.CurieAICard-module__border-r-12___NTy17 {
  border-radius: 12px !important;
}

.CurieAICard-module__border-r-16___FAzaw {
  border-radius: 16px !important;
}

.CurieAICard-module__border-r-50___zeBO0 {
  border-radius: 50% !important;
}

.CurieAICard-module__primary-border___dx9Oy {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.CurieAICard-module__primary-border-b___EQ6jY {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.CurieAICard-module__primary-border-t___pO4MA {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.CurieAICard-module__primary-border-l___nghOP {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.CurieAICard-module__primary-border-r___Ymbk2 {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.CurieAICard-module__secondary-border____Izvu {
  border: 1px solid #637768;
}

.CurieAICard-module__secondary-border-b___fmNDR {
  border-bottom: 1px solid #637768;
}

.CurieAICard-module__secondary-border-t___WMa2q {
  border-top: 1px solid #637768;
}

.CurieAICard-module__secondary-border-l___XBxTy {
  border-left: 1px solid #637768;
}

.CurieAICard-module__secondary-border-r___eeQU8 {
  border-right: 1px solid #637768;
}

.CurieAICard-module__gap-0___SveRw {
  gap: 0 !important;
}

.CurieAICard-module__gap-2___sVruO {
  gap: 2px !important;
}

.CurieAICard-module__gap-4___OjIj5 {
  gap: 4px !important;
}

.CurieAICard-module__gap-5___mgqSX {
  gap: 5px !important;
}

.CurieAICard-module__gap-6___KjJVb {
  gap: 6px !important;
}

.CurieAICard-module__gap-8___coz8l {
  gap: 8px !important;
}

.CurieAICard-module__gap-10___KvHBv {
  gap: 10px !important;
}

.CurieAICard-module__gap-12___V2Web {
  gap: 12px !important;
}

.CurieAICard-module__gap-14___Y21cs {
  gap: 14px !important;
}

.CurieAICard-module__gap-16___HLdlT {
  gap: 16px !important;
}

.CurieAICard-module__gap-18___PFsC6 {
  gap: 18px !important;
}

.CurieAICard-module__gap-20___XKSyz {
  gap: 20px !important;
}

.CurieAICard-module__gap-24___SYYho {
  gap: 24px !important;
}

.CurieAICard-module__gap-26___q7VjY {
  gap: 26px !important;
}

.CurieAICard-module__gap-30___k40oK {
  gap: 30px !important;
}

.CurieAICard-module__gap-32___MspWr {
  gap: 32px !important;
}

.CurieAICard-module__gap-40___bVNMg {
  gap: 40px !important;
}

.CurieAICard-module__gap-50___fzKpg {
  gap: 50px !important;
}

.CurieAICard-module__flex-1___Itgc5 {
  flex: 1;
}

.CurieAICard-module__flex-none___SzFJB {
  flex: none !important;
}

.CurieAICard-module__flex-column___G2bG_ {
  display: flex;
  flex-direction: column !important;
}

.CurieAICard-module__flex-row___Seezx {
  display: flex;
  flex-direction: row !important;
}

.CurieAICard-module__vertically-centered___rQIsM {
  display: flex;
  align-items: center !important;
}

.CurieAICard-module__horizontally-centered___LN6vY {
  display: flex;
  justify-content: center !important;
}

.CurieAICard-module__horizontally-end___BQKgT {
  display: flex;
  justify-content: end !important;
}

.CurieAICard-module__vertically-start___yrrgL {
  display: flex;
  align-items: start !important;
}

.CurieAICard-module__space-between___wK3uv {
  display: flex;
  justify-content: space-between !important;
}

.CurieAICard-module__flex-wrap___n_70n {
  flex-wrap: wrap !important;
}

.CurieAICard-module__height-100___L57z6 {
  height: 100%;
}

.CurieAICard-module__width-50___bKj4L {
  width: 50% !important;
}

.CurieAICard-module__width-100___FDOJt {
  width: 100%;
}

.CurieAICard-module__cursor-pointer___GlHQg {
  cursor: pointer;
}

.CurieAICard-module__cursor-not-allowed___Y03x9 {
  cursor: not-allowed !important;
}

.CurieAICard-module__absolute-centered___XZCEZ {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.CurieAICard-module__absolute___rt27X {
  position: absolute;
}

.CurieAICard-module__relative____ygkk {
  position: relative;
}

.CurieAICard-module__fixed___m_qr7 {
  position: fixed;
}

.CurieAICard-module__visible___MN4_h {
  opacity: 1;
}

.CurieAICard-module__invisible___HTQrA {
  opacity: 0;
}

.CurieAICard-module__col-90___UmLoP {
  width: 90% !important;
}

.CurieAICard-module__col-auto___OfdrG {
  width: auto !important;
}

.CurieAICard-module__medical-tabs___Hm9ZQ {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.CurieAICard-module__medical-table-new___Z9cBT {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CurieAICard-module__medical-table-new___Z9cBT:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CurieAICard-module__medical-table-new___Z9cBT::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CurieAICard-module__medical-table-new___Z9cBT::-webkit-scrollbar-track {
  display: none;
}
.CurieAICard-module__medical-table-new___Z9cBT.CurieAICard-module__no-pagination___GstuW {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CurieAICard-module__medical-table-new___Z9cBT.CurieAICard-module__no-pagination___GstuW:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CurieAICard-module__medical-table-new___Z9cBT.CurieAICard-module__no-pagination___GstuW::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CurieAICard-module__medical-table-new___Z9cBT.CurieAICard-module__no-pagination___GstuW::-webkit-scrollbar-track {
  display: none;
}

.CurieAICard-module__medical-table-empty___w30kj {
  padding: 14px 40px !important;
}

.CurieAICard-module__icon-btn___HYEQ8 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.CurieAICard-module__search-icon___Hhkes {
  width: 24px;
  height: 24px;
  align-self: center;
}

.CurieAICard-module__disable-select___X1V5G {
  user-select: none;
}

.CurieAICard-module__break-word___UtpiR {
  word-break: break-word;
}

.CurieAICard-module__popup-clear-btn___nluUr {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.CurieAICard-module__scroll-m-b-20___lehAp {
  scroll-margin-bottom: 20px;
}

.CurieAICard-module__card___HlAcO {
  color: #375844;
  overflow: hidden;
}
.CurieAICard-module__card___HlAcO .CurieAICard-module__header___tErdz {
  background-color: #f1f3e7;
  padding: 5px 10px 10px 10px;
  line-height: normal;
}
.CurieAICard-module__card___HlAcO .CurieAICard-module__link___KMEd7 {
  padding: 5px 10px;
  line-height: 15px;
}
.CurieAICard-module__card___HlAcO .CurieAICard-module__footer___qY1TP {
  padding: 5px 10px;
}
.CurieAICard-module__card___HlAcO .CurieAICard-module__footer___qY1TP .CurieAICard-module__button___dfu5I {
  padding: 5px 8px;
  font-size: 9px !important;
  font-weight: 800 !important;
  border-radius: 9px !important;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/CurieAISidebar/CurieAICard/CurieAICard.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;EACA,gBAAA;AA8pBF;AA5pBE;EACE,yBAAA;EACA,2BAAA;EACA,mBAAA;AA8pBJ;AA3pBE;EACE,iBAAA;EACA,iBAAA;AA6pBJ;AA1pBE;EACE,iBAAA;AA4pBJ;AA1pBI;EACE,gBAAA;EACA,yBAAA;EACA,2BAAA;EACA,6BAAA;AA4pBN","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.card {\n  color: get-color(greenNew, dark);\n  overflow: hidden;\n\n  .header {\n    background-color: get-color(greenNew, lighter);\n    padding: 5px 10px 10px 10px;\n    line-height: normal;\n  }\n\n  .link {\n    padding: 5px 10px;\n    line-height: 15px;\n  }\n\n  .footer {\n    padding: 5px 10px;\n\n    .button {\n      padding: 5px 8px;\n      font-size: 9px !important;\n      font-weight: 800 !important;\n      border-radius: 9px !important;\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `CurieAICard-module__font-s-10___nYgd2`,
	"fontS12": `CurieAICard-module__font-s-12___CAtOC`,
	"fontS13": `CurieAICard-module__font-s-13___CDiyh`,
	"fontS14": `CurieAICard-module__font-s-14___U1dmi`,
	"fontS15": `CurieAICard-module__font-s-15___D8Njs`,
	"fontS16": `CurieAICard-module__font-s-16___KhNPG`,
	"fontS18": `CurieAICard-module__font-s-18___g7KBM`,
	"fontS20": `CurieAICard-module__font-s-20___6m7w5`,
	"fontS22": `CurieAICard-module__font-s-22___XSAel`,
	"fontS28": `CurieAICard-module__font-s-28___pkQTh`,
	"fontW400": `CurieAICard-module__font-w-400___rolsN`,
	"fontW500": `CurieAICard-module__font-w-500___SDN7j`,
	"fontW600": `CurieAICard-module__font-w-600___ud3Rt`,
	"fontW700": `CurieAICard-module__font-w-700____XNmU`,
	"p5": `CurieAICard-module__p-5___ORiFf`,
	"p12": `CurieAICard-module__p-12___VIN9Y`,
	"p16": `CurieAICard-module__p-16___FJnB7`,
	"p30": `CurieAICard-module__p-30___yIoUS`,
	"pB0": `CurieAICard-module__p-b-0___b2Hhc`,
	"pB5": `CurieAICard-module__p-b-5___jpEzI`,
	"pB10": `CurieAICard-module__p-b-10___l819O`,
	"pB12": `CurieAICard-module__p-b-12___ZaxUu`,
	"pB16": `CurieAICard-module__p-b-16___DgFT9`,
	"pB18": `CurieAICard-module__p-b-18___Auh0m`,
	"pB20": `CurieAICard-module__p-b-20___v5mGG`,
	"pB25": `CurieAICard-module__p-b-25___wROQj`,
	"pB30": `CurieAICard-module__p-b-30___Qrt4c`,
	"pB50": `CurieAICard-module__p-b-50___DySBs`,
	"pT0": `CurieAICard-module__p-t-0___d8ml7`,
	"pT12": `CurieAICard-module__p-t-12___i3WiH`,
	"pT16": `CurieAICard-module__p-t-16___miU_Y`,
	"pT18": `CurieAICard-module__p-t-18___oSDlh`,
	"pT20": `CurieAICard-module__p-t-20___VLEDk`,
	"pT30": `CurieAICard-module__p-t-30___xm9DS`,
	"pT40": `CurieAICard-module__p-t-40___xI_mo`,
	"pT50": `CurieAICard-module__p-t-50___r3NwQ`,
	"pL20": `CurieAICard-module__p-l-20___EMuKG`,
	"pL30": `CurieAICard-module__p-l-30___NFrb1`,
	"pL40": `CurieAICard-module__p-l-40___VQ5b6`,
	"pR16": `CurieAICard-module__p-r-16___pOg7u`,
	"pR20": `CurieAICard-module__p-r-20___N8fA9`,
	"pR30": `CurieAICard-module__p-r-30___rWuMj`,
	"pR50": `CurieAICard-module__p-r-50___ZdyCP`,
	"pR60": `CurieAICard-module__p-r-60___Og6Ua`,
	"mB1": `CurieAICard-module__m-b-1___o1W_A`,
	"mB2": `CurieAICard-module__m-b-2___YJ_4d`,
	"mB6": `CurieAICard-module__m-b-6___ibjPE`,
	"mB8": `CurieAICard-module__m-b-8___JG_Ym`,
	"mB10": `CurieAICard-module__m-b-10___oX4zV`,
	"mB14": `CurieAICard-module__m-b-14___f2S2Y`,
	"mB16": `CurieAICard-module__m-b-16___ykh7D`,
	"mB20": `CurieAICard-module__m-b-20___Pgz4O`,
	"mB22": `CurieAICard-module__m-b-22___Uc158`,
	"mB24": `CurieAICard-module__m-b-24___DhzIx`,
	"mB30": `CurieAICard-module__m-b-30___s3ehs`,
	"mB32": `CurieAICard-module__m-b-32___Bi4ur`,
	"mB40": `CurieAICard-module__m-b-40___kfwao`,
	"mT2": `CurieAICard-module__m-t-2___kkZIH`,
	"mT3": `CurieAICard-module__m-t-3___E7dUW`,
	"mT4": `CurieAICard-module__m-t-4___gf6sW`,
	"mT5": `CurieAICard-module__m-t-5___v8OsQ`,
	"mT8": `CurieAICard-module__m-t-8___tBz6T`,
	"mT10": `CurieAICard-module__m-t-10___qTcBi`,
	"mT15": `CurieAICard-module__m-t-15___as0Bl`,
	"mT16": `CurieAICard-module__m-t-16___EvBGL`,
	"mT20": `CurieAICard-module__m-t-20___hCEhV`,
	"mT22": `CurieAICard-module__m-t-22___ECQDO`,
	"mT30": `CurieAICard-module__m-t-30___cC2cs`,
	"mT32": `CurieAICard-module__m-t-32___FejeC`,
	"mLAuto": `CurieAICard-module__m-l-auto___ph0Fc`,
	"mL4": `CurieAICard-module__m-l-4___qDlvi`,
	"mL5": `CurieAICard-module__m-l-5___iVvMQ`,
	"mL6": `CurieAICard-module__m-l-6___stCVZ`,
	"mL8": `CurieAICard-module__m-l-8___DQgQZ`,
	"mL10": `CurieAICard-module__m-l-10___EoTJD`,
	"mL16": `CurieAICard-module__m-l-16___UlSHN`,
	"mL20": `CurieAICard-module__m-l-20___oKsiH`,
	"mL24": `CurieAICard-module__m-l-24___nD2X7`,
	"mL30": `CurieAICard-module__m-l-30___iwt9L`,
	"mL35": `CurieAICard-module__m-l-35___ra2HE`,
	"mL40": `CurieAICard-module__m-l-40___nYWcj`,
	"mR8": `CurieAICard-module__m-r-8___S5NTf`,
	"mR10": `CurieAICard-module__m-r-10___eUjJk`,
	"mR16": `CurieAICard-module__m-r-16___QJhq7`,
	"mR20": `CurieAICard-module__m-r-20___BRLSJ`,
	"mR24": `CurieAICard-module__m-r-24___OfR73`,
	"mR30": `CurieAICard-module__m-r-30___YtPv4`,
	"mR40": `CurieAICard-module__m-r-40___ZHfiA`,
	"borderR3": `CurieAICard-module__border-r-3___i0ddB`,
	"borderR4": `CurieAICard-module__border-r-4___sLJZe`,
	"borderR6": `CurieAICard-module__border-r-6___y25be`,
	"borderR10": `CurieAICard-module__border-r-10___D0dxM`,
	"borderR12": `CurieAICard-module__border-r-12___NTy17`,
	"borderR16": `CurieAICard-module__border-r-16___FAzaw`,
	"borderR50": `CurieAICard-module__border-r-50___zeBO0`,
	"primaryBorder": `CurieAICard-module__primary-border___dx9Oy`,
	"primaryBorderB": `CurieAICard-module__primary-border-b___EQ6jY`,
	"primaryBorderT": `CurieAICard-module__primary-border-t___pO4MA`,
	"primaryBorderL": `CurieAICard-module__primary-border-l___nghOP`,
	"primaryBorderR": `CurieAICard-module__primary-border-r___Ymbk2`,
	"secondaryBorder": `CurieAICard-module__secondary-border____Izvu`,
	"secondaryBorderB": `CurieAICard-module__secondary-border-b___fmNDR`,
	"secondaryBorderT": `CurieAICard-module__secondary-border-t___WMa2q`,
	"secondaryBorderL": `CurieAICard-module__secondary-border-l___XBxTy`,
	"secondaryBorderR": `CurieAICard-module__secondary-border-r___eeQU8`,
	"gap0": `CurieAICard-module__gap-0___SveRw`,
	"gap2": `CurieAICard-module__gap-2___sVruO`,
	"gap4": `CurieAICard-module__gap-4___OjIj5`,
	"gap5": `CurieAICard-module__gap-5___mgqSX`,
	"gap6": `CurieAICard-module__gap-6___KjJVb`,
	"gap8": `CurieAICard-module__gap-8___coz8l`,
	"gap10": `CurieAICard-module__gap-10___KvHBv`,
	"gap12": `CurieAICard-module__gap-12___V2Web`,
	"gap14": `CurieAICard-module__gap-14___Y21cs`,
	"gap16": `CurieAICard-module__gap-16___HLdlT`,
	"gap18": `CurieAICard-module__gap-18___PFsC6`,
	"gap20": `CurieAICard-module__gap-20___XKSyz`,
	"gap24": `CurieAICard-module__gap-24___SYYho`,
	"gap26": `CurieAICard-module__gap-26___q7VjY`,
	"gap30": `CurieAICard-module__gap-30___k40oK`,
	"gap32": `CurieAICard-module__gap-32___MspWr`,
	"gap40": `CurieAICard-module__gap-40___bVNMg`,
	"gap50": `CurieAICard-module__gap-50___fzKpg`,
	"flex1": `CurieAICard-module__flex-1___Itgc5`,
	"flexNone": `CurieAICard-module__flex-none___SzFJB`,
	"flexColumn": `CurieAICard-module__flex-column___G2bG_`,
	"flexRow": `CurieAICard-module__flex-row___Seezx`,
	"verticallyCentered": `CurieAICard-module__vertically-centered___rQIsM`,
	"horizontallyCentered": `CurieAICard-module__horizontally-centered___LN6vY`,
	"horizontallyEnd": `CurieAICard-module__horizontally-end___BQKgT`,
	"verticallyStart": `CurieAICard-module__vertically-start___yrrgL`,
	"spaceBetween": `CurieAICard-module__space-between___wK3uv`,
	"flexWrap": `CurieAICard-module__flex-wrap___n_70n`,
	"height100": `CurieAICard-module__height-100___L57z6`,
	"width50": `CurieAICard-module__width-50___bKj4L`,
	"width100": `CurieAICard-module__width-100___FDOJt`,
	"cursorPointer": `CurieAICard-module__cursor-pointer___GlHQg`,
	"cursorNotAllowed": `CurieAICard-module__cursor-not-allowed___Y03x9`,
	"absoluteCentered": `CurieAICard-module__absolute-centered___XZCEZ`,
	"absolute": `CurieAICard-module__absolute___rt27X`,
	"relative": `CurieAICard-module__relative____ygkk`,
	"fixed": `CurieAICard-module__fixed___m_qr7`,
	"visible": `CurieAICard-module__visible___MN4_h`,
	"invisible": `CurieAICard-module__invisible___HTQrA`,
	"col90": `CurieAICard-module__col-90___UmLoP`,
	"colAuto": `CurieAICard-module__col-auto___OfdrG`,
	"medicalTabs": `CurieAICard-module__medical-tabs___Hm9ZQ`,
	"medicalTableNew": `CurieAICard-module__medical-table-new___Z9cBT`,
	"noPagination": `CurieAICard-module__no-pagination___GstuW`,
	"medicalTableEmpty": `CurieAICard-module__medical-table-empty___w30kj`,
	"iconBtn": `CurieAICard-module__icon-btn___HYEQ8`,
	"searchIcon": `CurieAICard-module__search-icon___Hhkes`,
	"disableSelect": `CurieAICard-module__disable-select___X1V5G`,
	"breakWord": `CurieAICard-module__break-word___UtpiR`,
	"popupClearBtn": `CurieAICard-module__popup-clear-btn___nluUr`,
	"scrollMB20": `CurieAICard-module__scroll-m-b-20___lehAp`,
	"card": `CurieAICard-module__card___HlAcO`,
	"header": `CurieAICard-module__header___tErdz`,
	"link": `CurieAICard-module__link___KMEd7`,
	"footer": `CurieAICard-module__footer___qY1TP`,
	"button": `CurieAICard-module__button___dfu5I`
};
module.exports = ___CSS_LOADER_EXPORT___;
